import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {firstValueFrom} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class FraudProtectionService {
    gibUrl: string = ""
    gibCid: string = ""
    private apiUser: string = "";

    constructor(
        private http: HttpClient,
    ) {
        this.apiUser = `${environment.apiUser}`
    }


    async fetchFraudConfig(idPersona?: string, sso?: string) {
        try {
            const response = await firstValueFrom(this.getGibUrlAndId())
            if (response.fpUrl && response.fpId) {
                this.gibCid = response.fpId
                this.gibUrl = response.fpUrl

                if (idPersona && sso) {
                    this.initFraudProtection(idPersona, sso)
                } else {
                    this.initFraudProtection()
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    getGibUrlAndId() {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })
        return this.http.get<any>(`${this.apiUser}/protection`, {
            params: {
                fpUrl: "gib.url",
                fpId: "gib_canal_nbd"
            },
            headers: headers
        });
    }

    loadScript(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (window.gib) {
                resolve();
                return;
            }
            const script = document.createElement('script');
            script.src = '/assets/gibfp.js';
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => reject('Error al cargar el script de Group-IB');
            document.body.appendChild(script);
        });
    }

    initFraudProtection(idPersona?: string, sso?: string): void {
        this.loadScript()
            .then(() => {
                if (!window.gib) {
                    console.error('Group-IB no se ha cargado correctamente');
                    return;
                }
                window.gib.init({
                    cid: this.gibCid,
                    backUrl: this.gibUrl,
                    gafUrl: '//eu.id.group-ib.com/id.html',
                    forceFirstAlive: true,
                    silentAlive: true,
                });
                if (idPersona && sso) {
                    window.gib.setAuthStatus(window.gib.IS_AUTHORIZED);
                    window.gib.setIdentity(idPersona);
                    window.gib.setSessionID(sso);
                    window.gib.requestGeolocationPermissions();
                } else {
                    window.gib.setAuthStatus(window.gib.IS_GUEST);
                }
            })
            .catch((error) => console.error(error));
    }
}
